import { Country } from '../../constants/country/country';

// Countries that require an English-only address (no normalization API, frontend regex enforced)
export const ENGLISH_ONLY_ADDRESS_COUNTRIES = [
  Country.Kazakhstan,
  Country.Mongolia,
  Country.Azerbaijan,
  Country.Switzerland,
  Country.Denmark,
  Country.Japan,
  Country.UnitedArabEmirates,
  Country.SaudiArabia,
] as const;

export const ENGLISH_ONLY_REGEX = /^[a-zA-Z0-9\s.,\-'#/()]+$/;

export const isEnglishOnlyAddressCountry = (country: Country): boolean =>
  (ENGLISH_ONLY_ADDRESS_COUNTRIES as readonly Country[]).includes(country);
